import { IBrowserWorkflowApiConfigurationParams } from '@assess/browser/workflow-api';

export const workflowApi: IBrowserWorkflowApiConfigurationParams = {
  rootUrl: window.APP_CONFIG.WORKFLOW_ADDRESS,
};
